import { StrapiImage } from '../common/types';
import { Constants } from './constants';

export const getImageUrl = (image: StrapiImage) => {
  return `${Constants.baseBackApiUrl}${image.url}`;
};
